import { merge } from 'lodash';
import ReactApexChart from 'react-apexcharts';
// material
import { Card, CardHeader, Box } from '@mui/material';
//
import { BaseOptionChart } from '../../charts';
import {  useTranslation } from 'react-i18next';

// ----------------------------------------------------------------------

const CHART_DATA = [
  {
    name: 'Team A',
    // type: 'line', //'column',
    data: [
        { x: new Date('2018-02-12').getTime(), y: 76 }, 
        { x: new Date('2018-02-15').getTime(), y: 22 },
        { x: new Date('2018-03-15').getTime(), y: 22 },
        { x: new Date('2018-03-15').getTime(), y: 0 },
    ]
  }
  
];

export default function AppBarChart(props) {
//  const chartOptions = merge(BaseOptionChart(), );
  const {t} = useTranslation();
  
  const chartOptions = {
    chart: {
      type: 'bar',
      stacked: true,
      height: 450,
      zoom: {
        enabled: false
      },
      toolbar: {
        enabled:true,
        autoSelected: 'zoom'
      }
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        endingShape: 'rounded'
      },
    },
    dataLabels: {
      enabled: false
    },
    markers: {
      size: 0,
    },
    // stroke: {
    //   width: 2,
    //   curve: 'stepline'
    // },
    // fill: {
    //   type: 'gradient',
    //   gradient: {
    //     shadeIntensity: 1,
    //     inverseColors: false,
    //     opacityFrom: 1,
    //     opacityTo: 1,
    //     stops: [0, 90, 100]
    //   },
    // },
    yaxis: {
      labels: {
        formatter: function (val) {
          return (val ).toFixed(2);
        },
      },
      title: {
        text: t("barchart_y_label")
      },
    },
    xaxis: {
      labels: {
        formatter: function (val) {
          return (val ).toFixed(0) + ":00";
        },
      },
      title: {
        text: t("barchart_x_label")
      },
    },
    tooltip: {
      shared: false,
      y: {
        formatter: function (val) {
          return (val ).toFixed(2)
        }
      }
    }
  };

    if (props.data == null){
        return <div></div>
    }



    //   [
    //     { x: new Date('2018-02-12').getTime(), y: 76 }, 
    //     { x: new Date('2018-02-15').getTime(), y: 22 },
    //     { x: new Date('2018-03-15').getTime(), y: 22 },
    //     { x: new Date('2018-03-15').getTime(), y: 0 },
    // ]

  return (

      <Box sx={{ p: 3, pb: 1, pt:0 }} dir="ltr">
        <ReactApexChart type="bar" series={props.data} options={chartOptions} height={props.height} />
      </Box>
   
  );
}
